import { Button, Chip } from "@material-ui/core";
import {
  Box,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import { MagnifyingGlass, Plus, X } from "phosphor-react";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { fget } from "../../API/callsAPI";
import CreateOrEditTeamModal from "../ProjectPage/ProjectPageModals/CreateOrEditTeamModal/CreateOrEditTeamModal";
import Loader from "../Utilities/Loader/Loader";
import ManageTeamHeader from "./ManageTeamHeader";
import myTeamsPageStyles from "./MyTeamsPageStyles";
import ChitranSvg from "../Utilities/Svg/ChitranSvg";
import ErrorOrSuccessMessage from "../Utilities/ErrorOrSuccessMessage/ErrorOrSuccessMessage.component";

export default function MyTeamsPageOverview() {
  const history = useHistory();
  const classes = myTeamsPageStyles();
  const [myTeams, setMyTeams] = useState([]);
  const [isMyTeamsLoaded, setIsMyTeamsLoaded] = useState(false);
  const [isCreateTeamModalOpen, setIsCreateTeamModalOpen] = useState(false);
  const [refreshCounter, setRefreshCounter] = useState(0);
  const [isWelcomeTeamModalOpen, setIsWelcomeTeamModalOpen] = useState(false);
  const [snackValue, setSnackValue] = useState({
    isOpen: false,
    message: "",
    isError: false,
  });

  useEffect(() => {
    const handleGetTeams = async () => {
      try {
        const res = await fget({ url: "project-space/" });
        setMyTeams(res?.data?.results);
        setIsMyTeamsLoaded(true);
        if (res?.data?.count === 0) {
          setIsWelcomeTeamModalOpen(true);
        }
      } catch (error) {
        console.log(error);
      }
    };
    handleGetTeams();
  }, [refreshCounter]);

  return (
    <Box className={classes.root}>
      <ErrorOrSuccessMessage snackValue={snackValue} />
      <Box className={classes.contentContainer}>
        <ManageTeamHeader />
        <Box style={{ display: "flex", gap: "16px", height: "100%" }}>
          <Box style={{ width: "100%", height: "100%" }}>
            <Box className={classes.header}>
              <Box>
                <Typography
                  sx={{
                    color: "white",
                    fontSize: "26px",
                    fontWeight: 600,
                  }}
                >
                  My Teams{" "}
                  <span
                    style={{
                      color: "#6C65D9",
                      marginLeft: "14px",
                    }}
                  >
                    {myTeams?.length ?? 0}
                  </span>
                </Typography>
                <Typography fontSize="14px" color="#606479">
                  Click on a team to view more information
                </Typography>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: "16px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    backgroundColor: "#252A38",
                    borderRadius: "10px",
                    width: "200px",
                    padding: "0px 10px",
                  }}
                >
                  <MagnifyingGlass size={20} color="#606479" />
                  <TextField
                    inputProps={{
                      style: {
                        color: "#606479 !important",
                      },
                    }}
                    sx={{
                      paddingLeft: "4px",
                      "& .MuiInputBase-input": {
                        color: "#fff !important",
                        paddingLeft: "0px",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          border: "none",
                        },
                      },
                      "& .MuiInputBase-input": {
                        padding: "8px 0px",
                        color: "#606479",
                      },
                    }}
                    size="small"
                    fullWidth
                    placeholder="Search in list"
                  />
                </div>
                <Button
                  className={classes.inviteButton}
                  startIcon={<Plus />}
                  onClick={() => setIsCreateTeamModalOpen(true)}
                >
                  New Team
                </Button>
              </Box>
            </Box>
            <Box sx={{ height: "75%", mt: 2 }}>
              <TableContainer>
                <Table stickyHeader size="small">
                  <TableHead>
                    <TableRow>
                      <TableCell
                        align="left"
                        className={classes.tableHeaderCell}
                      >
                        Name
                      </TableCell>
                      <TableCell
                        align="left"
                        className={classes.tableHeaderCell}
                      >
                        Role
                      </TableCell>
                      <TableCell
                        align="left"
                        className={classes.tableHeaderCell}
                      >
                        People
                      </TableCell>
                      <TableCell
                        align="left"
                        className={classes.tableHeaderCell}
                      >
                        Plan
                      </TableCell>
                      <TableCell
                        align="left"
                        className={classes.tableHeaderCell}
                      >
                        Created At
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  {isMyTeamsLoaded ? (
                    <TableBody>
                      {myTeams?.length ? (
                        myTeams?.map((team) => (
                          <TableRow
                            onClick={() =>
                              history.push(`/my-teams/${team.id}?tab=members`)
                            }
                            key={team.id}
                            sx={{
                              cursor: "pointer",
                              "&:hover": {
                                backgroundColor: "#F9F9F914",
                              },
                            }}
                          >
                            <TableCell
                              align="left"
                              className={classes.tableCell}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                {team?.name}
                              </div>
                            </TableCell>
                            <TableCell
                              align="left"
                              className={classes.tableCell}
                            >
                              {team?.role ?? "--"}
                            </TableCell>
                            <TableCell
                              align="left"
                              className={classes.tableCell}
                            >
                              {team?.collaborators?.length ?? 0}
                            </TableCell>
                            <TableCell
                              align="left"
                              className={classes.tableCell}
                            >
                              <Chip
                                label={
                                  <Typography variant="body2">
                                    {team?.tier}
                                  </Typography>
                                }
                                style={
                                  team?.tier === "free"
                                    ? {
                                        backgroundColor: "transparent",
                                        color: "#606479",
                                        border: "2px solid #606479",
                                      }
                                    : {
                                        backgroundColor: "transparent",
                                        color: "#6C65D9",
                                        border: "2px solid #6C65D9",
                                      }
                                }
                              />
                            </TableCell>
                            <TableCell
                              align="left"
                              className={classes.tableCell}
                              style={{
                                minWidth: "120px",
                              }}
                            >
                              {new Intl.DateTimeFormat("en-US", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              }).format(new Date(team?.created_at))}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableCell
                          colSpan={5}
                          sx={{
                            borderBottom: "none",
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              width: "100%",
                              gap: "16px",
                              mt: 2,
                            }}
                          >
                            <ChitranSvg />
                            <Typography
                              sx={{
                                color: "#F9F9F9",
                                fontSize: "16px !important",
                              }}
                            >
                              Looks like there's nothing here ..
                            </Typography>
                          </Box>
                        </TableCell>
                      )}
                    </TableBody>
                  ) : (
                    <TableBody
                      sx={{
                        borderBottom: "none !important",
                      }}
                    >
                      <TableCell
                        className={classes.tableCell}
                        colSpan={5}
                        sx={{
                          borderBottom: "none !important",
                        }}
                      >
                        <Loader />
                      </TableCell>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Box>
          </Box>
        </Box>
      </Box>
      <Modal
        className={classes.flexCenter}
        open={isCreateTeamModalOpen}
        onClose={() => setIsCreateTeamModalOpen(false)}
      >
        <CreateOrEditTeamModal
          handleClose={() => setIsCreateTeamModalOpen(false)}
          handleRefresh={() => {
            setRefreshCounter(refreshCounter + 1);
            setIsCreateTeamModalOpen(false);
          }}
          setSnackValue={setSnackValue}
        />
      </Modal>
      <Modal
        className={classes.flexCenter}
        open={isWelcomeTeamModalOpen}
        onClose={() => setIsWelcomeTeamModalOpen(false)}
      >
        <Box
          sx={{
            backgroundColor: "#1B1D28",
            width: "600px",
            padding: "18px",
            borderRadius: "20px",
            // height:''
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: 600,
                color: "#F9F9F9",
              }}
            >
              Welcome to Teams!
            </Typography>
            <Button onClick={() => setIsWelcomeTeamModalOpen(false)}>
              <X size={20} />
            </Button>
          </Box>
          <Box
            sx={{
              backgroundColor: "#0000004D",
              padding: "18px",
              display: "flex",
              alignItems: "center",
              gap: "24px",
              marginTop: "18px",
              borderRadius: "10px",
            }}
          >
            <ChitranSvg height={180} width={140} />
            <Box sx={{ width: "90%" }}>
              <Typography sx={{ fontSize: "14px", color: "#F9F9F9" }}>
                Create a team, invite members, and collaborate seamlessly on
                projects.
              </Typography>
              <br />
              <Typography sx={{ fontSize: "14px", color: "#F9F9F9" }}>
                When you create a project linked to a team, all team members are
                automatically added, so everyone has access to the work they
                need to see.
              </Typography>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}
